import React from 'react';
import { Dimmer, Image } from 'semantic-ui-react';

const Loader = () => (
  <Dimmer active page data-testid='loading'>
    <div
      style={{
        margin: 'auto',
        width: '50%',
        padding: '10px'
      }}
    >
      <Image src='/img/general/loading.gif' size='small' centered />
    </div>
  </Dimmer>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/common/loader.js